import Component from '../base/component';
import keyCodes from '../../../mns-fe-utilities/keyCodes';
import getKeyCode from '../../../mns-fe-utilities/getKeyCode';

export default class Overlay extends Component {
    constructor(options) {
        if(!options.overlayId) {
            throw new Error('Missing option: overlayId');
        }
        super();
        const focusableElementsSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex=\'-1\'])';

        this.overlay = document.getElementById(options.overlayId);
        this.openTrigger = document.getElementById(options.openTriggerId);
        this.closeTrigger = this.overlay.querySelector('.overlay-content__close-trigger');
        this.contentHolder = this.overlay.querySelector('.overlay-content');
        this.bodysChildElements = Array.prototype.slice.call(document.body.childNodes).filter(element => element !== this.overlay && element.nodeType !== Node.TEXT_NODE);
        this.visible = false;
        this.animatedOpen = this.overlay.classList.contains('overlay--fly-out');
        this.backdrop = document.querySelector(`.overlay-backdrop--${options.overlayId}`);

        const overlayFocusableElements = Array.prototype.slice.call(this.overlay.querySelectorAll(focusableElementsSelector));
        const allFocusableElements = Array.prototype.slice.call(document.querySelectorAll(focusableElementsSelector));
        this.focusableElementsToHide = allFocusableElements.filter(element =>
            overlayFocusableElements.indexOf(element) === -1
        );

        this.addEventListeners();
    }

    addEventListeners() {
        if(this.openTrigger) {
            this.openTrigger.addEventListener('click', () => this.open());
        }
        this.closeTrigger.addEventListener('click', event => this.close(event));
        this.overlay.addEventListener('keydown', event => this.close(event));
        this.overlay.addEventListener('click', event => this.close(event));
        this.overlay.querySelector('.overlay-dialog').addEventListener('click', event => event.stopPropagation());
        this.overlay.addEventListener('webkitTransitionEnd', this.resetDisplay.bind(this));
    }

    resetDisplay() {
        if (!this.overlay.classList.contains('overlay--open')) {
            this.overlay.style.visibility = 'hidden';
            this.backdrop.classList.remove('overlay-backdrop--animated');
        }
    }

    open() {
        this.visible = true;
        this.lastFocusedElement = document.activeElement;
        document.body.style.overflow = 'hidden';
        this.overlay.classList.add('overlay--open');
        if (this.animatedOpen) {
            this.backdrop.classList.add('overlay-backdrop--animated');
            this.overlay.style.visibility = 'visible';
        }
        this.backdrop.classList.add('overlay-backdrop--show');
        this.contentHolder.setAttribute('tabindex', '0');
        this.contentHolder.focus();
        this.focusableElementsToHide.forEach(element => element.setAttribute('tabindex', '-1'));
        this.bodysChildElements.forEach(element => element.setAttribute('aria-hidden', 'true'));
    }

    close(event) {
        const keyCode = getKeyCode(event);

        if (this.visible && (!keyCode || keyCodes.escapeCodes.indexOf(keyCode) > -1)) {
            this.visible = false;
            document.body.style.overflow = 'auto';
            this.overlay.classList.remove('overlay--open');
            this.backdrop.classList.remove('overlay-backdrop--show');
            this.contentHolder.setAttribute('tabindex', '-1');
            this.focusableElementsToHide.forEach(element => element.setAttribute('tabindex', '0'));
            this.bodysChildElements.forEach(element => element.removeAttribute('aria-hidden'));
            this.lastFocusedElement.focus();
        }
    }
}
